<template>
  <div id="progress-bar" class="progress-bar">
    <div class="progress-bar-line" ref="progressBarLine">
      <div class="full" :style="{width: progressBarWidth + 'px'}"></div>
      <div class="empty"></div>
    </div>

    <div class="circle progress-bar-step"
         v-for="step in stepsCount"
         :class="{active: currentStep >= step, 'no-margin': step === 1}"
         :style="{'margin-left': stepCircleSpacing + 'px'}"
         :key="`progress-bar-step-${step}`">
      <span>
        <div class="check-symbol" v-if="currentStep >= step"></div>
        <span v-else>{{ step }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ProgressBarService from "../services/vue/components/ProgressBarService";

export default {
  name: "ProgressBar",

  data() {
    return {
      isMounted: false,
      forceRecompute: 0,
    };
  },

  computed: {
    ...mapGetters({
      currentView: 'navigation/getCurrentView',
    }),

    currentStep() {
      return ProgressBarService.getStep(this.currentView);
    },

    stepsCount() {
      return ProgressBarService.getStepsCount();
    },

    progressBarWidth() {
      if (this.currentStep === 1) return 0;

      return (this.currentStep - 1) * this.stepCircleSpacing + (this.currentStep * 21);
    },

    stepCircleSpacing() {
      this.forceRecompute;

      if (!this.isMounted) return 0;

      const circleWidth = 24;
      const progressBarWidth = Math.min(this.$refs.progressBarLine.offsetWidth, 375);

      return (progressBarWidth / (this.stepsCount - 1)) - circleWidth;
    },
  },

  mounted() {
    this.isMounted = true;

    window.addEventListener('resize', this.realignStepCircles);
  },

  destroyed() {
    window.removeEventListener('resize', this.realignStepCircles);
  },

  methods: {
    realignStepCircles() {
      this.forceRecompute++;
    },
  },
};
</script>
